import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { MSpinner, MSelect } from "components/Shared";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { connect } from "react-redux";
import responseHandler from "responseHandler";
import { sendCaseToUser, getSchedulingAssistants } from "requests/schedulingAssistant";

const SendCaseToUserQueue = props => {
  const mounted = useRef(true);
  const [schedulingUsersForAssign, setSchedulingUsersForAssign] = useState([]);
  const [schedulingUserToAssign, setSchedulingUserToAssign] = useState(null);  
  const [showEscalatingDialog, setShowEscalatingDialog] = useState(false);
  const [sendCaseNote, setSendCaseNote] = useState(null);
  const [escalating, setEscalating] = useState(false);

  useEffect(() => {
    getSchedulingAssistants((users) => mapSchedulingUsersForAssign(users), mounted);  
    return () => {
      mounted.current = false;
    };
  }, []);

  const mapSchedulingUsersForAssign = (users) => {
    let availUsers = users.map(user => {
      return { value: user.internetUserId, label: user.firstLastName };
    });
    setSchedulingUsersForAssign(availUsers);
  };

  const sendCaseToSchedulingUser = () => {
    setShowEscalatingDialog(false);
    setEscalating(true);
    sendCaseToUser({
      ControlIdNumber: props.controlNumber,
      Notes: sendCaseNote,
      AssignToInternetUserId: schedulingUserToAssign,
      TimeLog: null,
    }, () => {
      setEscalating(false);
      setSchedulingUserToAssign(null);
      props.makeSuccessToast("User Successfully Assigned");
    }, () => {
      setEscalating(false);
      setSchedulingUserToAssign(null);
      props.makeWarningToast("Unable to Assign User");
    }, mounted);
  };

  const sendToSchedulingUserCaseActions = [
    <Button
      className="m-t-10"
      key="continue"
      disabled={schedulingUserToAssign === null
        || (sendCaseNote === null || sendCaseNote === "")}
      onClick={() => sendCaseToSchedulingUser()}
    >
      Continue
    </Button>,
    <Button
      className="m-t-10"
      key="cancel"
      onClick={() => {
        setShowEscalatingDialog(false);
        setSchedulingUserToAssign(null);
      }}
    >
      Cancel
    </Button>
  ];  

  return (
    <>
      <Grid item xs={12}>
        <Button
          style={{width: "-webkit-fill-available"}}            
          key="send-to-user-queue"
          disabled={escalating}
          onClick={() => setShowEscalatingDialog(true)}>
          Send to User's Queue
        </Button>
      </Grid>
      <div id="send-to-manager-container">
        <Dialog
          open={showEscalatingDialog}
          onClose={() => setShowEscalatingDialog(false)}
          className="dialog-send-to-manager"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Send to User</DialogTitle>
          <DialogContent>
            <MSelect
              id="selectManager"
              placeholder={"Please select a user..."}
              options={schedulingUsersForAssign}
              onChange={option => option ? setSchedulingUserToAssign(option.value) : setSchedulingUserToAssign(null)}
              name={"User:"}
              className="md-full-width"
              getMenuPortalTarget={() => document.querySelector(".dialog-send-to-manager")}
            />
            <TextField
              id="dialog-send-case-note"
              type="text"
              inputProps={{ maxLength: 1000 }}
              label="Note"
              onChange={e => setSendCaseNote(e.target.value)}
              required
              multiline
              rows={3}
              variant="standard"
              fullWidth
            />           
          </DialogContent>
          <DialogActions>
            {sendToSchedulingUserCaseActions}
          </DialogActions>
        </Dialog>
        <Dialog
          open={escalating}
          maxWidth="sm"
        >
          <DialogTitle>Sending Case to User...</DialogTitle>
          <DialogContent>
            <MSpinner />
          </DialogContent>
        </Dialog>
      </div>        
    </>);
};

SendCaseToUserQueue.propTypes = {
  controlNumber: PropTypes.number.isRequired,  
  makeSuccessToast: PropTypes.func,
  makeWarningToast: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  makeSuccessToast(text) {
    responseHandler.customToast(text, "success", dispatch);
  },
  makeWarningToast(text) {
    responseHandler.customToast(text, "warning", dispatch);
  },
});

export default connect(null, mapDispatchToProps)(SendCaseToUserQueue);
